import { PlusCircle } from "@phosphor-icons/react";

import EmptyPlaceholder from "common/components/EmptyPlaceholder";
import RestrictedComponent from "common/components/RestrictedComponent";
import { Button } from "common/components/ui/Button";
import useAppStore from "common/hooks/useAppStore";

import LeadsImage from "assets/images/empty-placeholders/inbox.png";

export default function CreateCampaign() {
  const setIsCampaignModalOpen = useAppStore(
    (state) => state.setIsCampaignModalOpen,
  );

  return (
    <EmptyPlaceholder
      imageSrc={LeadsImage}
      title="No conversations to display"
      subtitle="It looks like you do not have any active LinkedIn conversations"
      actionComponent={
        <RestrictedComponent visibleFor={["campaigns_full"]}>
          <Button
            onClick={() => setIsCampaignModalOpen(true)}
            leftIcon={<PlusCircle weight="fill" />}
          >
            Create campaign
          </Button>
        </RestrictedComponent>
      }
    />
  );
}
